import React, { Fragment } from 'react';
import { scroller } from 'react-scroll';

import ProductVersionSection from '../ProductVersionSection';
import Select from '../../../../components/input/Select';
import Anchor from '../../../../components/link/Anchor';
import {
  PRODUCT_CURRENT_VERSION_SECTION_TITLE,
  PRODUCT_REJECT_TYPE_TEXT,
  PRODUCT_VERSION_SECTION_ID,
  PRODUCT_VERSION_SECTION_ID_LIST,
} from '../../../../constants/service/app/productConstants';
import { asyncSimpleModal } from '../../../../lib/common';
import './ProductVersionWrap.scss';

const ProductVersionWrap = ({ data, getProductVersionDetailMutate }) => {
  const {
    currentVersionInfo,
    currentVersionDetail,
    targetVersionDetailId,
    targetVersionDetail,
    productVersionList,
    productPropertyList,
    rejectReason,
  } = data;

  /**
   *  특정 패널을 스크롤 상위로 올리기
   */
  const scrollToTargetPanel = (name) => {
    /**
     *  현재 버전과 타겟 버전의 패널을 각각 스크롤 상위로 이동시킨다.
     */
    PRODUCT_VERSION_SECTION_ID_LIST.forEach((sectionId) => {
      scroller.scrollTo(`${sectionId}-${name}`, {
        smooth: true,
        containerId: sectionId,
      });
    });
  };

  return (
    <div className="product-version-wrap">
      {/*현재 버전*/}
      <ProductVersionSection
        className="current-version-section"
        sectionName={`${PRODUCT_CURRENT_VERSION_SECTION_TITLE} ${currentVersionInfo}`}
        sectionId={PRODUCT_VERSION_SECTION_ID.CURRENT_VERSION_SECTION}
        productDetail={currentVersionDetail}
        comparisonTarget={targetVersionDetail}
        productPropertyList={productPropertyList}
        scrollToTargetPanel={scrollToTargetPanel}
      />

      {/*특정 버전*/}
      <ProductVersionSection
        className="target-version-section"
        sectionName={
          <Fragment>
            <Select
              list={productVersionList}
              onChange={(productUpdateLogId) => getProductVersionDetailMutate.mutate({ productUpdateLogId })}
              value={targetVersionDetailId}
              isTable={true}
              size="default"
            />

            {/*특정 버전의 거절 사유*/}
            {rejectReason.reason ? (
              <Anchor
                color="primary"
                isUnderLine
                onClick={async () =>
                  await asyncSimpleModal({
                    title: PRODUCT_REJECT_TYPE_TEXT[rejectReason.type],
                    message: rejectReason.reason,
                  })
                }
                text="거절 사유"
              />
            ) : null}
          </Fragment>
        }
        sectionId={PRODUCT_VERSION_SECTION_ID.TARGET_VERSION_SECTION}
        productDetail={targetVersionDetail}
        comparisonTarget={currentVersionDetail}
        productPropertyList={productPropertyList}
        scrollToTargetPanel={scrollToTargetPanel}
      />
    </div>
  );
};

export default ProductVersionWrap;
